export const usersApi = (client) => ({
    list: (params) => client.get('/api/v1/users', { params }).then((r) => r.data),
    get: (id) => client.get(`/api/v1/users/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/users', body).then((r) => r.data),
    /// Bulk-create users from a parsed CSV. Transactional — every row
    /// lands or none does, so a re-run after fixing the spreadsheet is
    /// safe. Per-row failures come back as 422 with an `errors` array.
    bulkCreate: (users) => client.post('/api/v1/users/bulk', { users }).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/users/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/users/${id}`).then((r) => r.data),
    deactivate: (id) => client.post(`/api/v1/users/${id}/deactivate`).then((r) => r.data),
    reactivate: (id) => client.post(`/api/v1/users/${id}/reactivate`).then((r) => r.data),
    updateRole: (id, role) => client.patch(`/api/v1/users/${id}/role`, { role }).then((r) => r.data),
    adminResetPassword: (id) => client.post(`/api/v1/users/${id}/reset-password`).then((r) => r.data),
    forceLogout: (id) => client.post(`/api/v1/users/${id}/force-logout`).then((r) => r.data),
    /// Directly sets a user's password — no email, no consent, no old
    /// password. Super-admin only; for accounts whose email can't
    /// actually receive the normal reset link.
    forceSetPassword: (id, new_password) => client.post(`/api/v1/users/${id}/force-set-password`, { new_password }).then((r) => r.data),
    listSites: (id) => client.get(`/api/v1/users/${id}/sites`).then((r) => r.data),
    grantSites: (id, site_ids) => client.post(`/api/v1/users/${id}/sites`, { site_ids }).then((r) => r.data),
    /// `unassigned` lists any open/in_progress WOs/tasks freed up because
    /// this was the user's last grant on that site — empty otherwise.
    revokeSite: (id, siteId) => client.delete(`/api/v1/users/${id}/sites/${siteId}`).then((r) => r.data),
    grantAllSites: (id) => client.post(`/api/v1/users/${id}/sites/all`).then((r) => r.data),
    revokeAllSites: (id) => client.delete(`/api/v1/users/${id}/sites`).then((r) => r.data),
    // Profile (self)
    getProfile: () => client.get('/api/v1/me/profile').then((r) => r.data),
    updateProfile: (body) => client.patch('/api/v1/me/profile', body).then((r) => r.data),
    listSessions: () => client.get('/api/v1/me/sessions').then((r) => r.data),
    revokeSession: (sessionId) => client.delete(`/api/v1/me/sessions/${sessionId}`).then((r) => r.data),
    revokeAllSessions: () => client.post('/api/v1/me/sessions/revoke-all').then((r) => r.data),
    uploadAvatar: (file, onProgress) => {
        const form = new FormData();
        form.append('avatar', file);
        return client.post('/api/v1/me/avatar', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (e) => { if (onProgress && e.total)
                onProgress(Math.round((e.loaded / e.total) * 100)); },
        }).then((r) => r.data);
    },
    deleteAvatar: () => client.delete('/api/v1/me/avatar').then((r) => r.data),
});
//# sourceMappingURL=users.js.map